<template>
<div class="catalog">

  <!-- page header -->
  <page-heading :show="true" pageTitle="HEADER-CATALOG" :pageTitle2="$store.getters.getCatalogName"></page-heading>

  <!-- show loading indicator -->
  <loading-indicator :loading="isLoading"></loading-indicator>

  <div class="columns" v-if="!isLoading" style="position: relative;">
  
    <div v-show="isSaving" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(255,255,255,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
        <loading-indicator :loading="isSaving" color="#363636"></loading-indicator>
    </div>

    <div class="col-main">

      <div class="is-clearfix">

        <div class="is-pulled-left">

          <!-- SUCHE -->
          <div class="control has-icon search">
            <input class="input" type="text" v-model.trim="search" placeholder="Suchbegriff">
            <!-- <i class="fa icon-ak-suche"></i> -->
            <i class="fa fa-search" aria-hidden="true"></i>
          </div>

        </div>


        <div class="columns filters is-pulled-right">

          <div class="column is-narrow">
            <status-dropdown type="pageStatus" minWidth="230" label="SELECT_BOX-STATUS_" :data.sync="filterCatalogPageStatusSelected" :allowEmpty="true" placeholder="Seiten Status wählen" @change="onFilterSelect" class="small"></status-dropdown>
          </div>

          <div class="column is-narrow">
            <status-dropdown v-if="userRole=='Administrator'" minWidth="230" type="pageElementStatus" label="SELECT_BOX-FILTER_SITE_CATALOG_PAGE_ELEMENT_STATUS-" :data.sync="filterCatalogPageElementStatusSelected" :allowEmpty="true"
              placeholder="Element Status wählen" @change="onFilterSelect" class="small"></status-dropdown>
          </div>

          <div class="column is-narrow">

            <!-- FILTER: Sections -->
            <!--
                  <div class="control">
                      <span class="select">
                          <select v-model="filterCatalogSectionSelected" @change="onFilterSelect">
                              <option :value="null">{{ $t('SELECT-FILTER_CATALOG_SECTION') }}</option>
                              <option v-for="(catalogSection, key) in catalogSections" :value="catalogSection.id">{{ catalogSection.topicName }}</option>
                              <option value="specialPages">Cover, Lesezeichen</option>
                          </select>
                      </span>
                  </div>
                  -->

            <!-- FILTER: Sections -->
            <div class="column">
              <form-input inputType="select" label="FILTER_CATALOG_SECTION" @input="onFilterSelect" selectFieldName="name" selectCustomLabel="topicName" :selectAllowEmpty="true" v-model="filterCatalogSectionSelected"
                :selectOptions="filterSectionOptions" :showLabel="false" :showLabelInOptions="false"></form-input>
            </div>

          </div>

          <div class="column is-narrow">
            <span :class="[isFilterActive ? 'is-blue' : 'is-disabled', 'button reset-filter']" @click="resetFilter" :title="isFilterActive ? 'Klick um Filter zurückzusetzen' : ''">
              <span class="icon is-small"><i class="icon-ak-reset" aria-hidden="true"></i></span>
            </span>
          </div>

        </div>


      </div> <!-- // is-clearfix -->


      <!-- FRONT COVER PAGE -->
      <template v-if="showSpecialRow('frontCoverPage')">
        <special-page :page="catalogFixedSites.frontCoverPage" viewType="cluster" type="front"></special-page>
      </template>

      <div v-if="filteredCatalog.length == 0" class="has-text-centered" style="background: #f1f1f1; padding: 50px 20px; border-radius: 4px;">
        <span class="icon is-small" style="line-height: 24px;"><i class="icon-ak-info"></i></span>
        <span>Für diesen Katalog wurden noch keine Seiten angelegt</span>
      </div>

      <!-- CLUSTER -->
      <draggable v-model="filteredCatalog" :options="{
              handle: allowDrag === true ? '.drag-handle' : '.drag-deactivated',
              draggable: '.list-complete-item',
              filter: '.heading',
              scrollSensitivity: 100,
              scrollSpeed: 15
          }" @sort="onDragComplete($event)">

        <div v-for="(pages, key) in filteredCatalog" :key="pages[0].id" :class="[pages[0].status && pages[0].status.name ? pages[0].status.name : '',
              key == 0 || (filteredCatalog[key-1] && filteredCatalog[key-1][0].section && pages[0].section && filteredCatalog[key-1][0].section.name != pages[0].section.name) ? 'marginTop' : '',
              'columns catalogPageRow list-complete-item status']">

          <div v-if="pages[0] && pages[0].section && pages[0].section.name" class="sectionHeading">{{ pages[0].section.topicName }} <small>({{ pages[0].section.name }})</small></div>

          <!-- col SECTION NAME -->
          <!--
        		<div class="column is-2" :title="pages[0].status ? 'Status: ' + $t('SELECT_BOX-FILTER_SITE_CATALOG_STATUS-'+pages[0].status.name) : ''">
        			<div class="page-sectionName"><template v-if="pages[0].section">{{ pages[0].section.topicName }} ( {{ pages[0].section.name }})</template></div>
        			<div class="page-name"><template v-if="pages[0].name">{{ pages[0].name }}</template></div>
        			<div class="page-manufacturer"><template v-if="pages[0].manufacturer">{{ pages[0].manufacturer.name }}</template></div>
            </div>
            -->

          <!-- col pageElements LEFT -->
          <div class="column pageElementsLeftBox">
            <div class="pageElementInfo">
              <!-- <div class="page-sectionName"><template v-if="pages[0].section">{{ pages[0].section.topicName }} ( {{ pages[0].section.name }})</template></div> -->
              <div class="page-name"><template v-if="pages[0].name">{{ pages[0].name }}</template></div>
              <div class="page-manufacturer"><template v-if="pages[0].manufacturer">{{ pages[0].manufacturer.name }}</template></div>
            </div>

            <page-elements v-if="pages[0]" :catalogPageElements="pages[0].catalogPageElements"></page-elements>
          </div>

          <!-- col DOUBLE PAGE Preview -->
          <div class="column is-2 pagesContainerBox">
            <double-page :pages="filteredCatalog[key]" viewType="cluster" @click.native="editDoublePage(filteredCatalog[key][0].id, filteredCatalog[key][1].id)" @editDoublePage="editDoublePage" @insertDoublePage="insertDoublePage"
              @cloneDoublePage="cloneDoublePage" @deleteDoublePage="deleteDoublePage"></double-page>
          </div>

          <!-- col pageElements RIGHT -->
          <div class="column pageElementsRightBox">
            <div class="pageElementInfo">
              <div v-if="pages[1] && pages[1].manufacturer && pages[1].manufacturer.name && pages[0].manufacturer && pages[0].manufacturer.name && pages[1].manufacturer.name != pages[0].manufacturer.name">
                <!-- <div class="page-sectionName"><template v-if="pages[1].section">{{ pages[1].section.topicName }} ( {{ pages[1].section.name }})</template></div> -->
                <div class="page-name"><template v-if="pages[1].name">{{ pages[1].name }}</template></div>
                <div class="page-manufacturer"><template v-if="pages[1].manufacturer">{{ pages[1].manufacturer.name }}</template></div>
              </div>
            </div>

            <page-elements v-if="pages[1]" :catalogPageElements="pages[1].catalogPageElements"></page-elements>
          </div>

          <!-- col OPTIONS -->
          <div class="column is-narrow options">
            <template v-if="userRole != 'Redaktion'">
              <div class="drag-handle" title="verschieben">
                <span class="icon"><i class="icon-ak-move"></i></span>
              </div>
            </template>
          </div>

        </div>

      </draggable>


      <!-- BACK COVER (U4) PAGE -->
      <template v-if="showSpecialRow('backCoverPage')">
        <!-- <div class="catalogPageRow heading"><h2>Back Cover</h2></div> -->
        <special-page :page="catalogFixedSites.backCoverPage" viewType="cluster" type="back"></special-page>
      </template>


      <!-- LESEZEICHEN PAGE -->
      <template v-if="showSpecialRow('bookmarkPage')">
        <!-- <div class="catalogPageRow heading"><h2>Lesezeichen</h2></div> -->
        <special-page :page="catalogFixedSites.bookmarkPage" viewType="cluster" type="bookmark"></special-page>
      </template>


    </div>

    <div class="col-aside">

      <affix :offset="50">

        <template v-if="userRole != 'Redaktion'">

          <!-- new Page -->
          <custom-button name="CAT_NEW_SITE" type="blue" icon="icon-ak-hinzufuegen" @click.native="newPage"></custom-button>

          <!-- total pages -->
          <p v-if="totalPages">{{ totalPages }}
            <lang labelKey="CATALOG-PAGES_TOTAL"></lang>
          </p>

          <!-- Changelog -->
          <custom-button name="CATALOG-BTN-LAST_CHANGES" type="dark" icon="icon-ak-history" @click.native="goHistory" v-if="userRole=='Administrator'"></custom-button>

          <!-- Export Seitenspiegel -->
          <export-button export="catalog" btnTitle="SITE_BTN_EXP_CATALOG_SEITENSPIEGEL" modalTitle="MODAL_HEADER-EXPORT_CATALOG"></export-button>

          <!-- Upload Cover -->
          <div class="sidebox">

            <vue-dropzone ref="vueDropzone" id="vueDropzone" url="fileProcessing/upload?preset=catalogCover" :thumbnailWidth="145" :thumbnailHeight="67" :maxFiles="1" acceptedFiles=".jpg,.jpeg,.png"
              dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Cover hochladen" v-on:vdropzone-removed-file="dzCoverRemove" v-on:vdropzone-mounted="dzCoverInit" v-on:vdropzone-success="dzCoverSuccess" dzClass="dzSingle">
            </vue-dropzone>

          </div>

          <!-- Reminders -->
          <div class="sidebox" v-if="userRole == 'Administrator' && ['kornelia', 'bruktayt', 'andreas', 'matthias'].indexOf(this.activeUser.username) > -1">

            <div class="heading">
              <lang labelKey='MANUFACTURER-REMINDERS'></lang>
            </div>

            <custom-button name="MANUFACTURER-BTN-REMINDER" type="dark" icon="icon-ak-send" :isDisabled="reminderStatus.printApprovalReminderCount == 0" @click.native="reminder('sendPrintApprovalReminder', reminderStatus.printApprovalReminderCount)">
              <template slot="next-to-icon" v-if="reminderStatus.printApprovalReminderCount > 0"> ({{ reminderStatus.printApprovalReminderCount }})</template>
              <small v-if="reminderStatus.lastPrintApprovalReminderSendDate != null">zuletzt gesendet: {{ formatDate2(reminderStatus.lastPrintApprovalReminderSendDate) }}</small>
            </custom-button>

            <custom-button name="MANUFACTURER-BTN-REQUEST" type="dark" icon="icon-ak-send" :isDisabled="reminderStatus.printApprovalRequestCount == 0" @click.native="reminder('sendPrintApprovalRequest', reminderStatus.printApprovalRequestCount)">
              <template slot="next-to-icon" v-if="reminderStatus.printApprovalRequestCount > 0"> ({{ reminderStatus.printApprovalRequestCount }})</template>
              <small v-if="reminderStatus.lastPrintApprovalRequestSendDate != null">zuletzt gesendet: {{ formatDate2(reminderStatus.lastPrintApprovalRequestSendDate) }}</small>
            </custom-button>

          </div>

        </template>

      </affix>

    </div> <!-- // col-aside -->

  </div>


  <modal :title="modal.title" :width="modal.width" :is-show="showModal" transition="fade" :backdrop-closable="false" @close="closeModal()" :class="modal.class">


    <template v-if="modal.isSending && progressStatus != null && progressStatus.status != 'Finished'">

      <template v-if="progressStatus.status == 'Error'">

        <div class="has-text-centered" style="margin-bottom: 5px;">
          PROBLEM ...:<br />
          <span style="color: red; ">{{ progressStatus.log }}</span>
        </div>

      </template>

      <template v-else>

        <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
        <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

      </template>

    </template>

    <template v-else-if="progressStatus != null && progressStatus.status == 'Finished'">

      <alert type="success">Die Reminder wurden erfolgreich verschickt!</alert>

    </template>

    <template v-else>

      <div class="has-text-centered">
        <!-- <lang :labelKey="'SITE-MODAL_TEXT-'+modal.type"></lang> -->
        {{ $t(('MANUFACTURER-MODAL_TEXT-'+modal.type).toUpperCase()).replace('{RECIPIENT_COUNT}', modal.count) }}
      </div>

    </template>


    <div slot="footer">

      <template v-if="!isSending && progressStatus != null && progressStatus.status == 'Finished'">

        <a class="button" @click="closeModal()">schließen</a>

      </template>

      <template v-else>

        <a class="button" @click="closeModal">{{ modal.txtCancel }}</a>
        <a :class="['button is-primary', { 'is-loading': modal.isSending }]" @click="reminderSend()">
          <span class="icon is-small">
            <i class="icon-ak-send" aria-hidden="true"></i>
          </span>
          {{ modal.txtSubmit }}
        </a>

      </template>

    </div>

  </modal>


</div>
</template>


<script>
import pageElements from './incl-catalogPageElement';
import email from '../utils/email/sendEmail';
import exportButton from '../utils/exportButton';
import doublePage from './incl-doublePage';
import specialPage from './incl-specialPage';
import statusDropdown from '../utils/incl-statusDropdown';
import draggable from 'vuedraggable';
import vueDropzone from '../utils/dropzoneWrapper'

export default {

  name: 'catalog',

  components: {
    email,
    draggable,
    doublePage,
    specialPage,
    pageElements,
    exportButton,
    statusDropdown,
    vueDropzone
  },

  data() {

    return {
      isLoading: false,
      isSaving: false,
      allowDragging: true,
      modalErrorMsg: false,
      catalog: [],
      catalogPages: [],
      catalogSections: [],
      filterSectionOptions: [],
      catalogFixedSites: false,
      search: null,
      isFilterActive: false,
      filterCatalogPageStatusSelected: '',
      filterCatalogPageElementStatusSelected: '',
      filterCatalogSectionSelected: null,

      reminderStatus: null,
      progressStatus: null,
      refreshIntervalId: null,

      showModal: false,
      modal: {
        title: "",
        width: 520,
        txtCancel: 'abbrechen',
        txtSubmit: 'senden',
        count: null,
        isSending: false,
        class: ""
      },

      prevRoute: null,

    }
  },

	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.prevRoute = from
		})
	},

  created() {
    // get filter status from store
    this.filterCatalogPageStatusSelected = this.$store.getters.getCatalogFilter('filterCatalogPageStatusSelected');
    this.filterCatalogPageElementStatusSelected = this.$store.getters.getCatalogFilter('filterCatalogPageElementStatusSelected');
    this.filterCatalogSectionSelected = this.$store.getters.getCatalogFilter('filterCatalogSectionSelected');
    this.search = this._search;

    // set our reset filter button to inacative/active in case any of the above filters is not null
    this.isFilterActive = this.filterStatusChanged;

    // fetch catalog data
    this.fetchData();

  },

  mounted() {

  },

  computed: {

    allowDrag() {
      if (this.allowDragging == true && this.filterCatalogPageStatusSelected == null && this.filterCatalogSectionSelected == null && this.filterCatalogPageElementStatusSelected == null && this.search == null) {
        return true;
      }
      return false;
    },

    _search() {
      return this.$store.state.activeFilter.catalog.search ? this.$store.state.activeFilter.catalog.search : null;
    },

    filteredCatalog: {

      get: function() {
        // return this._searchCatalog(this.catalog, this.search);
        return this._searchCatalog();
      },
      set: function(newList) {
        this.catalog = newList;
      }

    },

    catalogPageStatus() {
      return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_STATUS');
    },

    catalogPageElementStatus() {
      return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS');
    },

    totalPages() {

      var count = 0;

      for (var i = 0; i < this.catalog.length; i++) {

        this.catalog[i].forEach(function(page) {

          if (typeof page == 'undefined') {
            return;
          }

          if (page.sortorder != 0 && page.sortorder != (this.$store.state.catalogPagesTotal - 1)) {
            count++;
          }

        }.bind(this));
      }

      return count;

    },

    filterStatusChanged() {

      return (this.filterCatalogPageStatusSelected != null ||
        this.filterCatalogPageElementStatusSelected != null ||
        this.filterCatalogSectionSelected != null ||
        (this.search != null && this.search != "")
      );

    },


  },

  watch: {

    filterStatusChanged() {
      this.isFilterActive = this.filterStatusChanged;
    },

  },

  methods: {

    reminder(type, count) {

      this.modal.title = this.$t("MANUFACTURER-MODAL_TITLE-" + type.toUpperCase());
      this.modal.width = 520;
      this.modal.txtSubmit = "absenden";
      this.modal.txtCancel = "abbrechen";
      this.modal.type = type;
      this.modal.count = count;
      this.showModal = true;

    },

    reminderSend() {

      this.modal.isSending = true;

      let url = this.$config.api + 'manufacturer/' + this.modal.type;
      var self = this;

      this.axios.get(url)
        .then(response => {

          var taskLogId = response.data.taskLogId;

          self.refreshIntervalId = setInterval(function() {

            self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
              .then(function(response) {

                self.progressStatus = response.data;

                if (['Finished', 'Error'].indexOf(response.data.status) > -1) {
                  clearInterval(self.refreshIntervalId);
                  self.modal.isSending = false;
                }

              });

          }.bind(self), 800);

        });

    },

    closeModal() {

      clearInterval(this.refreshIntervalId);
      this.progressStatus = null;
      this.refreshIntervalId = null;
      this.showModal = false;
      this.modal.isSending = false;
      this.modal.class = null;

    },

    newPage() {
      this.$router.push({
        name: 'catalogPageNew'
      });
    },

    goHistory() {
      this.$router.push({
        name: 'catalogChangeLog'
      });
    },

    resetFilter() {

      this.filterCatalogPageStatusSelected = null;
      this.filterCatalogPageElementStatusSelected = null;
      this.filterCatalogSectionSelected = null;
      this.search = null;

      var self = this;

      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogPageStatusSelected',
        value: self.filterCatalogPageStatusSelected
      });
      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogPageElementStatusSelected',
        value: self.filterCatalogPageElementStatusSelected
      });
      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogSectionSelected',
        value: self.filterCatalogSectionSelected
      });
      this.$store.commit('setCatalogFilter', {
        type: 'search',
        value: self.search
      });


      this._filterCatalog();

    },

    showSpecialRow(type) {

      // check if this type is available at all ...
      if (this.isLoading || !this.catalogFixedSites[type]) {
        return false;
      }

      if (this.filterCatalogPageStatusSelected == null &&
        this.filterCatalogPageElementStatusSelected == null &&
        this.search == null &&
        (this.filterCatalogSectionSelected == null || this.filterCatalogSectionSelected == 'specialPages')
      ) {
        return true;
      }

      return false;

    },

    onFilterSelect() {

      var self = this;

      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogPageStatusSelected',
        value: self.filterCatalogPageStatusSelected
      });
      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogPageElementStatusSelected',
        value: self.filterCatalogPageElementStatusSelected
      });
      this.$store.commit('setCatalogFilter', {
        type: 'filterCatalogSectionSelected',
        value: self.filterCatalogSectionSelected
      });

      this._filterCatalog();

    },

    _filterCatalog() {

      var self = this;

      setTimeout(function() {

        var filteredCatalog = [];

        // reset catalog
        if (self.filterCatalogPageStatusSelected == null && self.filterCatalogPageElementStatusSelected == null && self.filterCatalogSectionSelected == null) {

          self.catalogPages.forEach(function(catalogPage, index) {
            self.addDoublePageToFilteredCatalog(filteredCatalog, index);
          }, self);

        }

        // filter catalog
        else {

          // go through all pages and add matching double pages to the result
          self.catalogPages.forEach(function(catalogPage, index) {

            var siteQualifies = false;

            // filter page status
            // -----------------------------------------
            if (self.filterCatalogPageStatusSelected != null) {

              if (catalogPage.status && catalogPage.status.id == self.filterCatalogPageStatusSelected.id) {

                siteQualifies = true;

              } else {

                siteQualifies = false;
                return true;

              }

            }

            // filter page element status
            // -----------------------------------------
            if (self.filterCatalogPageElementStatusSelected != null) {

              var catalogPageElementStatusQualified = false;

              for (var i = 0; i < catalogPage.catalogPageElements.length; i++) {

                if (catalogPage.catalogPageElements[i].status.id == self.filterCatalogPageElementStatusSelected.id) {

                  catalogPageElementStatusQualified = true;
                  break;
                }

              }

              if (!catalogPageElementStatusQualified) {
                siteQualifies = false;
                return true;
              } else {
                siteQualifies = true;
              }

            }

            // filter section
            // -----------------------------------------
            if (self.filterCatalogSectionSelected != null) {

              siteQualifies = catalogPage.section != null && catalogPage.section.id == self.filterCatalogSectionSelected.id ? true : false;

              if (!siteQualifies) {
                return true;
              }

            }

            // search
            // -----------------------------------------
            if (self.search != null) {

              // console.log("search: ", self.search);

            }


            // if any of the above conditions get true,
            // we call the addDoublePageToFilteredCatalog function
            if (siteQualifies) {
              self.addDoublePageToFilteredCatalog(filteredCatalog, index);
            }

          }, self);

        }

        self.filteredCatalog = filteredCatalog;

      }, 20);

    },

    _searchCatalog() {

      // if there is no search string or the search string is too short we
      // return the whole list
      if (this.search == null || this.search.length < 3) {
        return this.catalog;
      }

      // this.isFilterActive = true;

      // make sure the search string is lowercase
      var searchString = this.search.toLowerCase();

      // add search string to our store
      this.$store.commit('setCatalogFilter', {
        type: 'search',
        value: searchString
      })

      var filteredCatalog = [];

      // go through all pages and add matching double pages to the result
      this.catalogPages.forEach(function(catalogPage, index) {

        // concatenate searchable values
        var fields = [catalogPage.name];

        // check if there is a manufacturer attached
        if (catalogPage.manufacturer != null) {

          fields.push(catalogPage.manufacturer.name, catalogPage.manufacturer.extRef);

        }

        // get all product placements
        fields.push(catalogPage.catalogPageElements.reduce(function(s, catalogPageElement) {
          return s + catalogPageElement.contentElement.contentElementData.reduce(function(s, contentElementData) {
            // if contentElement is a product, return product name and product extref,
            // otherwise return the page title
            return s + (contentElementData.product ? contentElementData.product.name + ' ' + contentElementData.product.extRef : contentElementData.value);

          }, '');

        }, ''));

        // concatenate our values and search the resulting string
        if (fields.join(' ').toLowerCase().indexOf(searchString) != -1) {
          this.addDoublePageToFilteredCatalog(filteredCatalog, index);
        }
      }, this);

      return filteredCatalog;

    },

    addDoublePageToFilteredCatalog(list, index) {

      // make sure the page is not already there
      if (list.filter(function(i) {
          return i[0].id == this.catalogPages[index].id || i[1].id == this.catalogPages[index].id;
        }, this).length == 0) {

        // this is a "second" page
        if (index % 2) {

          list.push([this.catalogPages[index - 1], this.catalogPages[index]]);

        } else {

          list.push([this.catalogPages[index], this.catalogPages[index + 1]]);

        }

      }

    },

    insertDoublePage(page1, page2) {

      if (this.isLoading || this.isSaving) return;

      var page = this.catalogPages.filter(function(i) {
          return i.id == page2;
        }).shift(),
        catalogPage, i;

      if (!page) {
        console.error("Seite konnte nicht gefunden werden!");
        return;
      }

      for (i = 1; i <= 2; i++) {

        catalogPage = {
          catalog: page.catalog.id,
          catalogPageElements: [],
          status: this.catalogPageStatus.CREATED,
          pageLayout: 1
        };

        // insert after the second page
        this.catalogPages.splice(page.sortorder + i, 0, catalogPage);

      }

      this.spreadCatalogPages();

      // re-sort, save is automatically handled;
      this.updateCatalog({
        isSilent: false,
        msg: 'MSG-SUCCESS-DOUBLE_PAGE_INSERTED'
      });


    },

    cloneDoublePage(page1, page2) {

      if (this.isLoading || this.isSaving) return;

      if (typeof page1 == 'undefined' || typeof page2 == 'undefined') {
        this.$notify.open({
          content: 'Fehler (keine IDs übergeben)',
          type: 'danger'
        });
        return;
      }

      var page = this.catalogPages.filter(function(i) {
        return i.id == page2;
      }).shift();

      if (!page) {
        console.error("Seite konnte nicht gefunden werden!");
        return;
      }

      this.catalogPages
        // grab the content pages contained in the double page
        .filter(function(contentPage) {
          return [page1, page2].indexOf(contentPage.id) != -1;
        })
        // clone each
        .forEach(function(contentPage, index) {

          var cloned = JSON.parse(JSON.stringify(contentPage));

          delete cloned.id;

          // reset several props for the cloned page
          cloned.status = this.catalogPageStatus.CREATED;
          cloned.thread = null;
          cloned.catalogPageElements.splice(0, cloned.catalogPageElements.length);

          
          //this.catalogPages.splice(index + 2, 0, cloned);
          this.catalogPages.splice(page.sortorder + index + 1, 0, cloned);

        }, this);


      this.spreadCatalogPages();

      // re-sort, save is automatically handled;
      this.updateCatalog({
        isSilent: false,
        msg: 'MSG-SUCCESS-DOUBLE_PAGE_CLONED'
      });

    },

    deleteDoublePage(page1ID, page2ID) {

      if (this.isLoading || this.isSaving) return;

      if (typeof page1ID == 'undefined' || typeof page2ID == 'undefined') {
        this.$notify.open({
          content: 'Fehler (keine IDs übergeben)',
          type: 'danger'
        });
        return;
      }

      var self = this;

      // Pass true for isSilent to suppress the mixin's default toast
      self.entityDelete('catalogPage', page1ID, 'CONFIRMATION-DELETE_DOUBLE_PAGE', true)
        .then(function() {

          // remove from catalogPage list
          for (var i = self.catalogPages.length; i--;) {
            if ([page1ID, page2ID].indexOf(self.catalogPages[i].id) != -1) {
              self.catalogPages.splice(i, 1);
            }
          }

          self.spreadCatalogPages();

          // update the page sortorder
          if (self.catalogPages.length > 0) {
            self.updateCatalog({
              isSilent: false,
              msg: 'MSG-SUCCESS-DOUBLE_PAGE_DELETED'
            });
          } else {
             self.$notify.open({
               content: self.$t ? self.$t('MSG-SUCCESS-DOUBLE_PAGE_DELETED') : 'Erfolgreich gelöscht',
               type: 'success'
             });
          }

        });

    },

    /*
		deleteDoublePage(page1, page2) {

			var self = this;

			self.entityDelete('catalogPage', [page1, page2], 'CONFIRMATION-DELETE_DOUBLE_PAGE')
				.then(function() {

					// remove from catalogPage list
					for (var i = self.catalogPages.length; i--;) {
						if ([page1, page2].indexOf(self.catalogPages[i].id) != -1) {
							self.catalogPages.splice(i, 1);
						}
					}

					// update the page sortorder
					self.updateCatalog( { isSilent: true } );

				});

		},
        */

    editDoublePage(page1, page2) {
      
      if (typeof page1 == 'undefined' || typeof page2 == 'undefined') {
        this.$notify.open({
          content: 'Fehler (keine IDs übergeben)',
          type: 'danger'
        });
        return;
      }
      
      // save the scroll position
      const scrollPosition = Math.round(document.documentElement.scrollTop);
      localStorage.setItem('scrollPosition', scrollPosition);


      this.$router.push({
        name: 'catalogPage',
        params: {
          'page1ID': page1,
          'page2ID': page2
        }
      });
    },

    onDragComplete() {

      var list = [];

      this.catalog.forEach(function(i) {
        list.push(i[0], i[1]);
      });

      this.catalogPages = list;

      // re-sort, save is automatically handled;
      this.updateCatalog({
        isSilent: false,
        msg: 'MSG-SUCCESS-DOUBLE_PAGE_MOVED'
      });

    },

    updateCatalog(options) {

      options = (typeof options === 'undefined') ? null : options;

      // assign the new sortorder
      this.catalogPages.forEach(function(catalogPage, index) {
        catalogPage.sortorder = index;
      });

      // save catalog
      this.saveCatalog(options);

    },

    saveCatalog(options) {

      var self = this;
      this.allowDragging = false;
      this.isSaving = true;

      // Extract the success message and suppress the mixin's default toast
      var successMsg = (options && options.msg && (!options.isSilent)) ? options.msg : null;
      if (options) {
        options.isSilent = true;
      }

      this.entityCreateOrUpdate('catalogPage', self.catalogPages, options)
        .then(function(response) {

          // assign the new sortorder
          self.catalogPages.forEach(function(catalogPage, index) {

            // catalogPage.sortorder = index;

            // if there was a new entry (insert or duplicate), assign the new id from the response
            // by identifying the corresponding entries with the sortorder
            if (typeof catalogPage.id == 'undefined') {
              catalogPage.id = response.catalogPage.find(arr => arr.sortorder === catalogPage.sortorder).id;
            }

          });

          // convert pages to double pages
          self.spreadCatalogPages();

          // set total number of pages in out store
          self.$store.commit('setCatalogPagesTotal', self.catalog.length * 2);

          self._filterCatalog();

          // re allow drag & drop
          self.allowDragging = true;
          self.isSaving = false;

          // show the toast message AFTER everything is done and the overlay is gone
          if (successMsg) {
            self.$nextTick(function() {
              self.$notify.open({
                content: self.$t ? self.$t(successMsg) : successMsg,
                type: 'success'
              });
            });
          }

        }).catch(function(error) {
          self.allowDragging = true;
          self.isSaving = false;
          console.error(error);
          
          self.$notify.open({
            content: 'Fehler beim Speichern des Katalogs aufgetreten',
            type: 'danger'
          });
        });

    },

    // this function is responsible for linking singular pages into double pages
    spreadCatalogPages() {

      this.catalog = [];

      for (var i = 0; i < this.catalogPages.length; i += 2) {
        this.catalog.push(this.catalogPages.slice(i, i + 2));
      }

    },

    fetchData() {

      var self = this;

      this.isLoading = true;

      // fetch "cover", "u4", "lesezeichen"
      function getCatalogFixedSites() {
        return self.axios.get(self.$config.api + 'catalog?filters[id]=' + self.catalogId + '&include=catalog.frontCoverPage,frontCoverPage.catalogPages,catalogPage.preview,catalogPage.status,catalog.backCoverPage,catalog.bookmarkPage');
      }

      // fetch sections
      function getCatalogSections() {
        return self.axios.get(self.$config.api + 'catalog?include=catalog.catalogSections&filters[id]=' + self.catalogId + '&orderBy=catalogSection.sortorder');
      }

      // get reminder status
      function reminderStatus() {
        return self.axios.get(self.$config.api + 'manufacturer/reminderStatus');
      }

      this.axios.all([getCatalogFixedSites(), getCatalogSections(), reminderStatus()])
        .then(self.axios.spread(function(fixedSites, sections, reminderStatus) {

          self.reminderStatus = reminderStatus.data;
          // console.log(self.reminderStatus);

          // catalog sections
          self.catalogSections = sections.data.catalog[0].catalogSections;

          // prepare filter section options
          self.filterSectionOptions = self.catalogSections;

          /*
          self.filterSectionOptions.push({
          name: 'cover',
          topicName: 'Cover, Lesezeichen'
          });

          console.log("filterSectionOptions: ", self.filterSectionOptions);
          <option :value="null">{{ $t('SELECT-FILTER_CATALOG_SECTION') }}</option>
          <option v-for="(catalogSection, key) in catalogSections" :value="catalogSection.id">{{ catalogSection.topicName }}</option>
          <option value="specialPages">Cover, Lesezeichen</option>
          */


          // these are the "fixed" sites like "cover", "u4", "lesezeichen",...
          self.catalogFixedSites = fixedSites.data.catalog[0];

          // fetch catalogPages
          self.entityGetList('catalogPage', {
              'filters[catalog.id]': self.catalogId,
              'include': [
                'catalogPage.catalog',
                'catalogPage.manufacturer',
                'catalogPage.catalogPageElements',
                'catalogPage.status',
                'catalogPage.section',
                'catalogPage.pageLayout',
                'catalogPageElement.status',
                'catalogPageElement.contentElement',
                'contentElement.type',
                'contentElement.contentElementData',
                'contentElementData.product',
                'product.productVariants',
                'product.productVouchers',
                'productVoucher.productVoucherProductVariants',
                'catalog.coverAsset'
              ].join(','),
              'orderBy': 'sortorder,catalogPageElement.sortorder'
            }, 'catalogPages')
            .then(function() {

              // convert pages to double pages
              self.spreadCatalogPages();

              // set total number of pages in out store
              self.$store.commit('setCatalogPagesTotal', self.catalog.length * 2);

              // if userRole is of type "Redaktion", set the catalog filtering to status "Content-Erstellung (Redaktion)";
              if (self.userRole == 'Redaktion') {

                // self.$store.commit('setCatalogFilter', { type: 'filterCatalogPageStatusSelected', value: self.catalogPageStatus.READY });
                self.filterCatalogPageStatusSelected = self.catalogPageStatus.READY;
                // self.filterCatalogStatus();

              }

              self._filterCatalog();

              self.isLoading = false;


              // only apply a scrollTo if we're coming from a "catalogPage"
              if(self.prevRoute.name == 'catalogPage') {

                // Scroll-Position nach dem Laden der Daten wiederherstellen
                const scrollPosition = localStorage.getItem('scrollPosition');

                if (scrollPosition) {
                  // console.log("scroll to position: ", scrollPosition);
                  self.$nextTick(() => {
                    window.scrollTo({
                      top: scrollPosition,
                      left: 0,
                      behavior: "smooth",
                    });
                  })
                }

              }

            });


        }));

    },


    // dropzone cover handling
    // ---------------------------------------------------------------------

    dzCoverInit() {

      var self = this;

      if (self.catalogPages.length == 0)
        return;

      if (self.catalogPages[0].catalog.coverAsset) {

        // set the url
        let url = self.$config.assets + self.catalogPages[0].catalog.coverAsset.path + '/' + self.catalogPages[0].catalog.coverAsset.filename;
        var mockFile = {
          id: 'assetCover',
          name: self.catalogPages[0].catalog.coverAsset.filename,
          type: 'image/*',
          size: 123
        }

        // add mockFile to our dropzone
        self.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

      }

    },

    dzCoverSuccess(file) {

      var result = JSON.parse(file.xhr.response);

      this.catalogPages.forEach(function(catalogPage) {
        catalogPage.catalog.coverAsset = {
          filename: result.fileName,
          path: result.dir,
          uploadFilename: file.name
        }
      });

      this.saveCatalog({
        isSilent: true
      });

    },

    dzCoverRemove(file, error, xhr) {

      if (typeof file === 'undefined') {
        return;
      }

      this.catalogPages.forEach(function(catalogPage) {
        catalogPage.catalog.coverAsset = null;
      });

      this.saveCatalog({
        isSilent: true
      });

    }

  }

}
</script>


<style lang="scss" scoped>
@import '~../../assets/css/variables.scss';

.catalogPageRow.status {
    border-left: 10px solid $statusCreated;
}
.catalogPageRow.status.CREATED {
    border-left: 10px solid $statusCreated;
}
.catalogPageRow.status.READY {
    border-left: 10px solid $statusReady;
}
.catalogPageRow.status.EDITED {
    border-left: 10px solid $statusEdited;
}
.catalogPageRow.status.LAYOUTED {
    border-left: 10px solid $statusLayouted;
}
.catalogPageRow.status.REVISED {
    border-left: 10px solid $statusRevised;
}
.catalogPageRow.status.APPROVED {
    border-left: 10px solid $statusApproved;
}
.catalogPageRow.status.PRINT_APPROVED {
    border-left: 10px solid $statusPrintApproved;
}
.catalogPageRow.status.REVIEW {
    border-left: 10px solid $statusReview;
}
</style>


<style scoped>
.list-complete-item {
  transition: all .3s;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}

.drag-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  height: auto;
  border-left: 1px solid #f1f1f1;
  transition: color .3s ease;
}

.drag-handle .icon {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}


.col-main {
  margin-bottom: 80px;
}

.catalogPageRow {
  margin: 0 0 5px 0;
  min-height: 100px;
  background: #fff;
}

.catalogPageRow:hover {
  background: #f6f6f6;
}

.catalogPageRow>.column:first-child {
  text-align: left;
}

.catalogPageRow>.column:last-child {
  position: relative;
  width: 25px;
}

.catalogPageRow.marginTop {
  margin-top: 80px;
}
</style>




<style>
.page-sectionName {
  text-transform: uppercase;
  font-size: 12px;
  color: #999;
}

.page-name {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #000;
  word-break: break-all;
}

.page-manufacturer {
  margin: 5px 0;
  font-size: 12px;
  font-style: italic;
  color: #aaa;
}

.sortable-ghost {
  opacity: .25 !important;
}

.pagesContainerBox {
  min-width: 250px;
}


/* pageElementBox */
.pageElementBox ul li {
  min-height: 30px;
  border-radius: 2px;
}

.column .pageElementInfo {
  min-height: 50px;
}

.pageElementsLeftBox .pageElementBox ul li {
  text-align: left;
}

.pageElementsRightBox .pageElementBox ul li {
  text-align: right;
}

.pageElementBox .statusCircle {
  width: .5rem;
  height: .5rem;
  border-radius: .5rem;
  position: absolute;
  z-index: 9999;
  top: 50%;
  transform: translateY(-50%);
}

.pageElementsLeftBox .pageElementBox .statusCircle {
  right: 2%;
}

.pageElementsRightBox .pageElementBox .statusCircle {
  left: 2%;
}

.catalogPageRow {
  position: relative;
  border-radius: 2px;
}

.catalogPageRow .sectionHeading {
  display: none;
  position: absolute;
  top: -55px;
  left: 0;
  right: 0;
  height: 50px;
  width: 100%;
  font-size: 1.4rem;
  text-transform: uppercase;
  padding: 10px 0 0 0;
  color: #999;
}

.catalogPageRow.marginTop .sectionHeading {
  display: block;
}
</style>
